import React from "react";
import { Helmet } from "react-helmet";

const TermsOfUse = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Use – Webs2PDF | Legal Usage Guidelines</title>
        <meta
          name="title"
          content="Terms of Use – Webs2PDF | Legal Usage Guidelines"
        />
        <meta
          name="description"
          content="Read the terms and conditions for using Webs2PDF’s services. This policy outlines user responsibilities, limitations, and legal agreements."
        />
        <link rel="canonical" href="https://webs2pdf.com/terms-of-use" />
      </Helmet>
      <div className="hero-section-wrap policy-wrap">
        <div className="container">
          <h1>Terms & Conditions</h1>
          <p>
            <b>Effective Date::</b> June 20, 2025
          </p>
          <h3>Acceptance of Terms</h3>
          <p>
            By accessing or using <b>Webs2PDF.com</b> (the “Site,” “we,” “our,”
            or “us”), you (“you,” “User”) agree to be bound by these Terms &
            Conditions (“Terms”). If you do not agree, please do not use the
            Service.
          </p>

          <h3>Service Description</h3>
          <p>
            We provide two product models:
            <ul>
              <li>
                <strong>Instant Conversions</strong> (one‐time use): Convert any
                publicly accessible web page to a downloadable PDF delivered
                immediately after processing.
              </li>
              <li>
                <strong>Subscription Plans</strong> (Basic, Pro, Ultimate):
                Monthly access to bulk conversions, advanced features, and
                higher quotas.
              </li>
            </ul>
          </p>

          <h3>Permitted Use</h3>
          <p>
            You agree to use the Site and Service lawfully. You must not submit
            or convert content that is unlawful, infringing, defamatory, or
            violates any third‐party rights.
          </p>

          <h3>Intellectual Property</h3>
          <p>
            All Site software, design, branding, and content are our property or
            that of our licensors. Except for the PDFs you generate, you may not
            reproduce, distribute, or create derivative works from any part of
            the Site without written permission.
          </p>

          <h3>Disclaimer & Limitation of Liability</h3>
          <p>
            The Service is provided <b>“as is”</b> without warranties of any
            kind. We do not guarantee formatting accuracy or uninterrupted
            availability. To the maximum extent permitted by law, we are not
            liable for any direct, indirect, incidental, or consequential
            damages arising from your use of the Service.
          </p>

          <h3>Governing Law & Jurisdiction</h3>
          <p>
            These Terms are governed by the laws of Pakistan. Any dispute shall
            be submitted to the exclusive jurisdiction of the courts in Lahore,
            Pakistan.
          </p>

          <h3>Modifications</h3>
          <p>
            We may revise these Terms at any time. Continued use after changes
            constitutes acceptance of the revised Terms.
          </p>
        </div>
      </div>
    </>
  );
};

export default TermsOfUse;
